import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

import PaymentIcon from 'assets/images/payment-icon.svg';
import { PageTitle } from 'components';
import { useClaimPageQuery } from 'hooks';

import { SettleAll, SettleOne } from './components';

export const ShortfallSettlePage = (): JSX.Element => {
  const { t } = useTranslation();

  const { sequenceNo, claimId } = useClaimPageQuery();

  return (
    <>
      <Space direction="vertical" style={{ display: 'flex' }}>
        <PageTitle title={t('claimDetails.shortfall.settleShortfall')} icon={PaymentIcon} />

        {claimId !== undefined && sequenceNo !== undefined ? (
          <SettleOne claimId={claimId} sequenceNo={sequenceNo} />
        ) : (
          <SettleAll />
        )}
      </Space>
    </>
  );
};
